import React from 'react';
import {
  StapleTable,
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import DownloadFileTableRow from '../DownloadFileTableRow';
import { StapleTableHeadingStyled } from './styles';

export interface DownloadFile {
  id: string;
  name: string;
}
interface DownloadFilesTableProps extends ICustomizableElement {
  loading: boolean;
  filesList: DownloadFile[];
  onDownload: (id: string, name: string) => void;
}

const DownloadFilesTable = ({ loading, filesList, className, onDownload }: DownloadFilesTableProps): JSX.Element => {
  return (
    <div className={className}>
      <StapleTable loading={loading} totalElements={filesList.length}>
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="30rem">File Name</StapleTableHeading>
            <StapleTableHeadingStyled width="15rem" />
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {filesList.map((file, index) => (
            <DownloadFileTableRow
              name={file.name}
              key={file.id}
              indexNumber={index + 1}
              onDownload={() => onDownload(file.id, file.name)}
            />
          ))}
        </StapleTableBody>
      </StapleTable>
    </div>
  );
};

export default DownloadFilesTable;
